// Supabase ANON client for the browser.
// Uses the publishable/anon key (safe to embed in the bundle).
// RLS policies on public.users enforce that only allowlisted users see data.

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Check packages/frontend/.env.local',
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
});

export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:8080';
